import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { statements } from './Reducers/Statements.reducer';
import { payments } from './Reducers/Payments.reducer';
import { accountSummary } from './Reducers/AccountSummary.reducer';
import { customerTrips } from './Reducers/CustomerTrips.reducer';
import { invoices } from './Reducers/Invoices.reducer';
import { loader } from './Reducers/Loader.reducer';
import { paymentMethods } from './Reducers/PaymentMethods.reducer';
import { invoicesToPay } from './Reducers/PayInvoices.reducer';
import { toggleSettings } from './Reducers/ToggleSettings.reducer';
import { modalResult } from './Reducers/ModalResult.reducer'
import { myQuotes } from './Reducers/MyQuotes.reducer'

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    statements,
    payments,
    accountSummary,
    customerTrips,
    invoices,
    loader,
    paymentMethods,
    invoicesToPay,
    toggleSettings,
    modalResult,
    myQuotes
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
